import React, { useEffect } from "react";
import { useField } from "formik";
import * as yup from "yup";
import { keyFromIdentity } from "../helpers";
import { QuestionProps } from "../question";
import FormQuestionFaxNumber from "./fax";
import FormQuestionSelect from "./select";

export const validator = (
  question: QuestionProps,
  _questionsMap: Record<string, QuestionProps>,
  parent?: string,
  index?: number,
): Record<string, yup.AnySchema> => {
  const parentName = keyFromIdentity(question.identity, parent, index);
  const validatorBase = question.required ? yup.string().required() : yup.string();
  const numberValidator = validatorBase.nullable()
    .validPhoneNumber("Must be a valid 10 digit phone number");

  return {
    [parentName]: yup.object().shape({
      "number": numberValidator,
      "type": validatorBase
        .when("number", ([numberVal], schema) => {
          const number = Array.isArray(numberVal) ? numberVal[0] : numberVal;
          return number && String(number).trim().length ? schema.oneOf(["mobile", "landline"]) : schema;
        }),
    }),
  };
};

export const initial = (
  question: QuestionProps,
  _questionsMap: Record<string, QuestionProps>,
  parent?: string,
  index?: number,
): Record<string, Record<string, string>> => {
  const key = keyFromIdentity(question.identity, parent, index);
  return {
    [key]: { number: "", type: "" },
  };
};


const PhoneInput = (props : any): React.ReactElement => {
  const { name } = props;
  const [, , helpers] = useField({ name });
  // Validate on transition:
  useEffect(() => () => {
    helpers.setTouched(true);
  }, []);

  const selectData = {
    options: [
      { label: "Mobile", value: "mobile" },
      { label: "Landline", value: "landline" },
    ],
    layout: { type: "radio", wrap: true },
  };
  return (
    <>
      <FormQuestionFaxNumber {...props} name={`${name}.number`} />
      <FormQuestionSelect {...props} name={`${name}.type`} data={selectData} title="Phone type?"/>
    </>
  );
};

PhoneInput.initial = initial;
PhoneInput.validator = validator;
export default PhoneInput;
